<template>
  <div>
    <el-form :inline="true" label-width="66px">
      <el-form-item label="设备：">
        <span v-if="teles.length === 1">{{ teles && teles[0].name }}</span>
        <el-select
          v-else
          v-model="deviceId"
          clearable
          placeholder="请选择"
          style="width:100%;"
          @change="goSearch"
        >
          <el-option
            v-if="teles.length > 1"
            label="全部"
            :value="null"
          ></el-option>
          <el-option
            v-for="device in teles"
            :key="device.id"
            :label="device.name"
            :value="device.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-popover
        trigger="click"
        placement="left-start"
        popper-class="padding-none"
      >
        <date-picker
          v-loading="loadingCount"
          :date="day"
          :date-count="dateCount"
          @change="dateChange"
          @pre-change="monthChange"
        ></date-picker>
        <el-button slot="reference">日期：{{ day }}</el-button>
      </el-popover>
    </el-form>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker'
import { datePickOption } from '@/utlis/mixin'

export default {
  mixins: [datePickOption],
  components: { DatePicker },
  props: {
    loading: Boolean,
    loadingCount: Boolean,
    day: String,
    month: String,
    dateCount: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      beginDate: undefined,
      endDate: undefined,
      id: null,
      deviceId: null,
      state: null,
      searchOpen: false
    }
  },
  methods: {
    handleSearchOpen(v) {
      this.searchOpen = v
    },
    resetSearch() {
      this.beginDate = undefined
      this.endDate = undefined
      this.id = ''
      this.deviceId = null
      this.state = null
      this.goSearch()
    },
    goSearch() {
      const { beginDate, endDate, deviceId } = this
      this.$emit('change', { beginDate, endDate, deviceId })
    },
    dateChange(day) {
      if (day !== this.day) {
        this.$emit('date-change', day)
      }
    },
    monthChange(month) {
      if (month !== this.month) {
        if (!this.loading) this.$emit('month-change', month)
      }
    }
  }
}
</script>

<style lang="css" scoped></style>
